/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.espaceAnimateur.ts
 *
 * Messages de l'ESPACE ANIMATEUR et des corrections issues des recettes des
 * tutoriels du 2026-10-05 : horaire et jauge en lecture seule, capacité
 * réelle (jamais « ∞ »), vocabulaire propre à l'animateur, accès à « Mes
 * ateliers » depuis l'accueil et le menu, fiche d'entretien du mode
 * découverte. Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement, ni « salon »,
 * « atelier », « exposant » écrits en dur ; le vocabulaire passe par les
 * jetons {lex...}. Apostrophe typographique partout (en ICU, l'apostrophe
 * droite échappe l'accolade qui la suit).
 *
 * Mikael - chef de projet - 2026-10-06
 */
export const messagesEspaceAnimateurFr: Record<string, string> = {
  // ── Horaire et jauge fixés par l'organisation ──────────────────────────
  'workshopFields.schedule.locked':
    'L’horaire et la jauge sont fixés par l’organisation. Pour un changement, contactez-la.',
  'workshopFields.schedule.pending': 'L’organisation fixera l’horaire et la jauge.',
  'workshopFields.schedule.slot': '{start} à {end}',
  'workshopFields.schedule.slotWithCapacity':
    '{start} à {end}, {capacity, plural, one {# place} other {# places}}',
  'mesAteliers.error.scheduleLocked':
    'L’horaire et la jauge {lexWorkshopOfDef} sont fixés par l’organisation. Contactez-la pour tout changement.',
  'mesAteliers.gauge.countNoCapacity':
    '{confirmed, plural, =0 {Aucun inscrit} one {# inscrit·e} other {# inscrit·e·s}}',

  // ── Espace animateur : titres et accès ──────────────────────────────────
  'espaceAnimateur.titre': 'Mon espace animateur',
  'espaceAnimateur.intro':
    'Décrivez et publiez vos {lexWorkshopPlural}, suivez les inscriptions, puis contrôlez l’accès le jour J.',
  'espaceAnimateur.scanner': 'Contrôle d’accès',
  'espaceAnimateur.carte.titre': 'Votre espace animateur',
  'espaceAnimateur.carte.texte': 'Vos {lexWorkshopPlural}, leurs inscriptions et le contrôle d’accès.',
  'espaceAnimateur.carte.cta': 'Ouvrir mes {lexWorkshopPlural}',
  'espaceAnimateur.plus.mesAteliers': 'Mes {lexWorkshopPlural}',
  'espaceAnimateur.plus.espace': 'Mon espace animateur',
  'espaceAnimateur.role': 'Animateur {lexWorkshopOf}',

  // ── Capacité : jamais de symbole, rien quand elle n'est pas fixée ───────
  'workshopsAdmin.capacity.textNoCapacity': 'Inscrits : {registered}',
  'workshopsAdmin.field.timeSlots.capacity': 'Jauge (places)',
  'exhibitorScanner.access.counterNoCapacity': 'Présents : {attended} / {confirmed}',

  // ── Fiche d'entretien du mode découverte (données fictives) ─────────────
  'ficheEntretien.demo.bandeau':
    'Essai avec une personne fictive : rien n’est enregistré dans vos vraies fiches.',
  'ficheEntretien.demo.point.competences': 'Travail en équipe, sens du contact',
  'ficheEntretien.demo.point.langues': 'Anglais courant',
};
